export default "__VITE_ASSET__C5OQ76eW__"